import { isVue3 as Ft } from "vue-demi";
var Dt = typeof global == "object" && global && global.Object === Object && global;
const at = Dt;
var Nt = typeof self == "object" && self && self.Object === Object && self, Ut = at || Nt || Function("return this")();
const m = Ut;
var Gt = m.Symbol;
const O = Gt;
var it = Object.prototype, Bt = it.hasOwnProperty, Ht = it.toString, U = O ? O.toStringTag : void 0;
function Wt(e) {
  var t = Bt.call(e, U), r = e[U];
  try {
    e[U] = void 0;
    var n = !0;
  } catch {
  }
  var a = Ht.call(e);
  return n && (t ? e[U] = r : delete e[U]), a;
}
var Kt = Object.prototype, zt = Kt.toString;
function qt(e) {
  return zt.call(e);
}
var Xt = "[object Null]", Yt = "[object Undefined]", je = O ? O.toStringTag : void 0;
function j(e) {
  return e == null ? e === void 0 ? Yt : Xt : je && je in Object(e) ? Wt(e) : qt(e);
}
function w(e) {
  return e != null && typeof e == "object";
}
var Zt = "[object Symbol]";
function be(e) {
  return typeof e == "symbol" || w(e) && j(e) == Zt;
}
function Jt(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = Array(n); ++r < n; )
    a[r] = t(e[r], r, e);
  return a;
}
var Qt = Array.isArray;
const $ = Qt;
var Vt = 1 / 0, Le = O ? O.prototype : void 0, xe = Le ? Le.toString : void 0;
function ot(e) {
  if (typeof e == "string")
    return e;
  if ($(e))
    return Jt(e, ot) + "";
  if (be(e))
    return xe ? xe.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Vt ? "-0" : t;
}
function P(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function _e(e) {
  return e;
}
var kt = "[object AsyncFunction]", er = "[object Function]", tr = "[object GeneratorFunction]", rr = "[object Proxy]";
function ve(e) {
  if (!P(e))
    return !1;
  var t = j(e);
  return t == er || t == tr || t == kt || t == rr;
}
var nr = m["__core-js_shared__"];
const oe = nr;
var Me = function() {
  var e = /[^.]+$/.exec(oe && oe.keys && oe.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ar(e) {
  return !!Me && Me in e;
}
var ir = Function.prototype, or = ir.toString;
function L(e) {
  if (e != null) {
    try {
      return or.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var sr = /[\\^$.*+?()[\]{}|]/g, fr = /^\[object .+?Constructor\]$/, ur = Function.prototype, cr = Object.prototype, lr = ur.toString, pr = cr.hasOwnProperty, gr = RegExp(
  "^" + lr.call(pr).replace(sr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function dr(e) {
  if (!P(e) || ar(e))
    return !1;
  var t = ve(e) ? gr : fr;
  return t.test(L(e));
}
function hr(e, t) {
  return e == null ? void 0 : e[t];
}
function x(e, t) {
  var r = hr(e, t);
  return dr(r) ? r : void 0;
}
var yr = x(m, "WeakMap");
const ce = yr;
var Re = Object.create, br = function() {
  function e() {
  }
  return function(t) {
    if (!P(t))
      return {};
    if (Re)
      return Re(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}();
const _r = br;
function vr(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, r[0]);
    case 2:
      return e.call(t, r[0], r[1]);
    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }
  return e.apply(t, r);
}
function st(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var Tr = 800, $r = 16, Ar = Date.now;
function Or(e) {
  var t = 0, r = 0;
  return function() {
    var n = Ar(), a = $r - (n - r);
    if (r = n, a > 0) {
      if (++t >= Tr)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function wr(e) {
  return function() {
    return e;
  };
}
var mr = function() {
  try {
    var e = x(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const Q = mr;
var Pr = Q ? function(e, t) {
  return Q(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: wr(t),
    writable: !0
  });
} : _e;
const Sr = Pr;
var Er = Or(Sr);
const Ir = Er;
function Cr(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var jr = 9007199254740991, Lr = /^(?:0|[1-9]\d*)$/;
function Te(e, t) {
  var r = typeof e;
  return t = t ?? jr, !!t && (r == "number" || r != "symbol" && Lr.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function te(e, t, r) {
  t == "__proto__" && Q ? Q(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
function z(e, t) {
  return e === t || e !== e && t !== t;
}
var xr = Object.prototype, Mr = xr.hasOwnProperty;
function ft(e, t, r) {
  var n = e[t];
  (!(Mr.call(e, t) && z(n, r)) || r === void 0 && !(t in e)) && te(e, t, r);
}
function F(e, t, r, n) {
  var a = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var s = t[i], f = n ? n(r[s], e[s], s, r, e) : void 0;
    f === void 0 && (f = e[s]), a ? te(r, s, f) : ft(r, s, f);
  }
  return r;
}
var Fe = Math.max;
function Rr(e, t, r) {
  return t = Fe(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, a = -1, i = Fe(n.length - t, 0), o = Array(i); ++a < i; )
      o[a] = n[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = n[a];
    return s[t] = r(o), vr(e, this, s);
  };
}
function Fr(e, t) {
  return Ir(Rr(e, t, _e), e + "");
}
var Dr = 9007199254740991;
function $e(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Dr;
}
function re(e) {
  return e != null && $e(e.length) && !ve(e);
}
function Nr(e, t, r) {
  if (!P(r))
    return !1;
  var n = typeof t;
  return (n == "number" ? re(r) && Te(t, r.length) : n == "string" && t in r) ? z(r[t], e) : !1;
}
function ut(e) {
  return Fr(function(t, r) {
    var n = -1, a = r.length, i = a > 1 ? r[a - 1] : void 0, o = a > 2 ? r[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (a--, i) : void 0, o && Nr(r[0], r[1], o) && (i = a < 3 ? void 0 : i, a = 1), t = Object(t); ++n < a; ) {
      var s = r[n];
      s && e(t, s, n, i);
    }
    return t;
  });
}
var Ur = Object.prototype;
function Ae(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Ur;
  return e === r;
}
function Gr(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var Br = "[object Arguments]";
function De(e) {
  return w(e) && j(e) == Br;
}
var ct = Object.prototype, Hr = ct.hasOwnProperty, Wr = ct.propertyIsEnumerable, Kr = De(function() {
  return arguments;
}()) ? De : function(e) {
  return w(e) && Hr.call(e, "callee") && !Wr.call(e, "callee");
};
const V = Kr;
function zr() {
  return !1;
}
var lt = typeof exports == "object" && exports && !exports.nodeType && exports, Ne = lt && typeof module == "object" && module && !module.nodeType && module, qr = Ne && Ne.exports === lt, Ue = qr ? m.Buffer : void 0, Xr = Ue ? Ue.isBuffer : void 0, Yr = Xr || zr;
const B = Yr;
var Zr = "[object Arguments]", Jr = "[object Array]", Qr = "[object Boolean]", Vr = "[object Date]", kr = "[object Error]", en = "[object Function]", tn = "[object Map]", rn = "[object Number]", nn = "[object Object]", an = "[object RegExp]", on = "[object Set]", sn = "[object String]", fn = "[object WeakMap]", un = "[object ArrayBuffer]", cn = "[object DataView]", ln = "[object Float32Array]", pn = "[object Float64Array]", gn = "[object Int8Array]", dn = "[object Int16Array]", hn = "[object Int32Array]", yn = "[object Uint8Array]", bn = "[object Uint8ClampedArray]", _n = "[object Uint16Array]", vn = "[object Uint32Array]", h = {};
h[ln] = h[pn] = h[gn] = h[dn] = h[hn] = h[yn] = h[bn] = h[_n] = h[vn] = !0;
h[Zr] = h[Jr] = h[un] = h[Qr] = h[cn] = h[Vr] = h[kr] = h[en] = h[tn] = h[rn] = h[nn] = h[an] = h[on] = h[sn] = h[fn] = !1;
function Tn(e) {
  return w(e) && $e(e.length) && !!h[j(e)];
}
function Oe(e) {
  return function(t) {
    return e(t);
  };
}
var pt = typeof exports == "object" && exports && !exports.nodeType && exports, G = pt && typeof module == "object" && module && !module.nodeType && module, $n = G && G.exports === pt, se = $n && at.process, An = function() {
  try {
    var e = G && G.require && G.require("util").types;
    return e || se && se.binding && se.binding("util");
  } catch {
  }
}();
const R = An;
var Ge = R && R.isTypedArray, On = Ge ? Oe(Ge) : Tn;
const we = On;
var wn = Object.prototype, mn = wn.hasOwnProperty;
function gt(e, t) {
  var r = $(e), n = !r && V(e), a = !r && !n && B(e), i = !r && !n && !a && we(e), o = r || n || a || i, s = o ? Gr(e.length, String) : [], f = s.length;
  for (var c in e)
    (t || mn.call(e, c)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Te(c, f))) && s.push(c);
  return s;
}
function dt(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Pn = dt(Object.keys, Object);
const Sn = Pn;
var En = Object.prototype, In = En.hasOwnProperty;
function Cn(e) {
  if (!Ae(e))
    return Sn(e);
  var t = [];
  for (var r in Object(e))
    In.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function q(e) {
  return re(e) ? gt(e) : Cn(e);
}
function jn(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var Ln = Object.prototype, xn = Ln.hasOwnProperty;
function Mn(e) {
  if (!P(e))
    return jn(e);
  var t = Ae(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !xn.call(e, n)) || r.push(n);
  return r;
}
function D(e) {
  return re(e) ? gt(e, !0) : Mn(e);
}
var Rn = ut(function(e, t, r, n) {
  F(t, D(t), e, n);
});
const Fn = Rn;
var Dn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Nn = /^\w*$/;
function me(e, t) {
  if ($(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || be(e) ? !0 : Nn.test(e) || !Dn.test(e) || t != null && e in Object(t);
}
var Un = x(Object, "create");
const H = Un;
function Gn() {
  this.__data__ = H ? H(null) : {}, this.size = 0;
}
function Bn(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Hn = "__lodash_hash_undefined__", Wn = Object.prototype, Kn = Wn.hasOwnProperty;
function zn(e) {
  var t = this.__data__;
  if (H) {
    var r = t[e];
    return r === Hn ? void 0 : r;
  }
  return Kn.call(t, e) ? t[e] : void 0;
}
var qn = Object.prototype, Xn = qn.hasOwnProperty;
function Yn(e) {
  var t = this.__data__;
  return H ? t[e] !== void 0 : Xn.call(t, e);
}
var Zn = "__lodash_hash_undefined__";
function Jn(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = H && t === void 0 ? Zn : t, this;
}
function C(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
C.prototype.clear = Gn;
C.prototype.delete = Bn;
C.prototype.get = zn;
C.prototype.has = Yn;
C.prototype.set = Jn;
function Qn() {
  this.__data__ = [], this.size = 0;
}
function ne(e, t) {
  for (var r = e.length; r--; )
    if (z(e[r][0], t))
      return r;
  return -1;
}
var Vn = Array.prototype, kn = Vn.splice;
function ea(e) {
  var t = this.__data__, r = ne(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : kn.call(t, r, 1), --this.size, !0;
}
function ta(e) {
  var t = this.__data__, r = ne(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function ra(e) {
  return ne(this.__data__, e) > -1;
}
function na(e, t) {
  var r = this.__data__, n = ne(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function S(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
S.prototype.clear = Qn;
S.prototype.delete = ea;
S.prototype.get = ta;
S.prototype.has = ra;
S.prototype.set = na;
var aa = x(m, "Map");
const W = aa;
function ia() {
  this.size = 0, this.__data__ = {
    hash: new C(),
    map: new (W || S)(),
    string: new C()
  };
}
function oa(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ae(e, t) {
  var r = e.__data__;
  return oa(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function sa(e) {
  var t = ae(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function fa(e) {
  return ae(this, e).get(e);
}
function ua(e) {
  return ae(this, e).has(e);
}
function ca(e, t) {
  var r = ae(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function E(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
E.prototype.clear = ia;
E.prototype.delete = sa;
E.prototype.get = fa;
E.prototype.has = ua;
E.prototype.set = ca;
var la = "Expected a function";
function Pe(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(la);
  var r = function() {
    var n = arguments, a = t ? t.apply(this, n) : n[0], i = r.cache;
    if (i.has(a))
      return i.get(a);
    var o = e.apply(this, n);
    return r.cache = i.set(a, o) || i, o;
  };
  return r.cache = new (Pe.Cache || E)(), r;
}
Pe.Cache = E;
var pa = 500;
function ga(e) {
  var t = Pe(e, function(n) {
    return r.size === pa && r.clear(), n;
  }), r = t.cache;
  return t;
}
var da = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ha = /\\(\\)?/g, ya = ga(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(da, function(r, n, a, i) {
    t.push(a ? i.replace(ha, "$1") : n || r);
  }), t;
});
const ba = ya;
function _a(e) {
  return e == null ? "" : ot(e);
}
function ht(e, t) {
  return $(e) ? e : me(e, t) ? [e] : ba(_a(e));
}
var va = 1 / 0;
function ie(e) {
  if (typeof e == "string" || be(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -va ? "-0" : t;
}
function yt(e, t) {
  t = ht(t, e);
  for (var r = 0, n = t.length; e != null && r < n; )
    e = e[ie(t[r++])];
  return r && r == n ? e : void 0;
}
function Ta(e, t, r) {
  var n = e == null ? void 0 : yt(e, t);
  return n === void 0 ? r : n;
}
function bt(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var $a = dt(Object.getPrototypeOf, Object);
const Se = $a;
var Aa = "[object Object]", Oa = Function.prototype, wa = Object.prototype, _t = Oa.toString, ma = wa.hasOwnProperty, Pa = _t.call(Object);
function vt(e) {
  if (!w(e) || j(e) != Aa)
    return !1;
  var t = Se(e);
  if (t === null)
    return !0;
  var r = ma.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && _t.call(r) == Pa;
}
function Sa() {
  this.__data__ = new S(), this.size = 0;
}
function Ea(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
function Ia(e) {
  return this.__data__.get(e);
}
function Ca(e) {
  return this.__data__.has(e);
}
var ja = 200;
function La(e, t) {
  var r = this.__data__;
  if (r instanceof S) {
    var n = r.__data__;
    if (!W || n.length < ja - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new E(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
function A(e) {
  var t = this.__data__ = new S(e);
  this.size = t.size;
}
A.prototype.clear = Sa;
A.prototype.delete = Ea;
A.prototype.get = Ia;
A.prototype.has = Ca;
A.prototype.set = La;
function xa(e, t) {
  return e && F(t, q(t), e);
}
function Ma(e, t) {
  return e && F(t, D(t), e);
}
var Tt = typeof exports == "object" && exports && !exports.nodeType && exports, Be = Tt && typeof module == "object" && module && !module.nodeType && module, Ra = Be && Be.exports === Tt, He = Ra ? m.Buffer : void 0, We = He ? He.allocUnsafe : void 0;
function $t(e, t) {
  if (t)
    return e.slice();
  var r = e.length, n = We ? We(r) : new e.constructor(r);
  return e.copy(n), n;
}
function Fa(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
function At() {
  return [];
}
var Da = Object.prototype, Na = Da.propertyIsEnumerable, Ke = Object.getOwnPropertySymbols, Ua = Ke ? function(e) {
  return e == null ? [] : (e = Object(e), Fa(Ke(e), function(t) {
    return Na.call(e, t);
  }));
} : At;
const Ee = Ua;
function Ga(e, t) {
  return F(e, Ee(e), t);
}
var Ba = Object.getOwnPropertySymbols, Ha = Ba ? function(e) {
  for (var t = []; e; )
    bt(t, Ee(e)), e = Se(e);
  return t;
} : At;
const Ot = Ha;
function Wa(e, t) {
  return F(e, Ot(e), t);
}
function wt(e, t, r) {
  var n = t(e);
  return $(e) ? n : bt(n, r(e));
}
function le(e) {
  return wt(e, q, Ee);
}
function Ka(e) {
  return wt(e, D, Ot);
}
var za = x(m, "DataView");
const pe = za;
var qa = x(m, "Promise");
const ge = qa;
var Xa = x(m, "Set");
const de = Xa;
var ze = "[object Map]", Ya = "[object Object]", qe = "[object Promise]", Xe = "[object Set]", Ye = "[object WeakMap]", Ze = "[object DataView]", Za = L(pe), Ja = L(W), Qa = L(ge), Va = L(de), ka = L(ce), I = j;
(pe && I(new pe(new ArrayBuffer(1))) != Ze || W && I(new W()) != ze || ge && I(ge.resolve()) != qe || de && I(new de()) != Xe || ce && I(new ce()) != Ye) && (I = function(e) {
  var t = j(e), r = t == Ya ? e.constructor : void 0, n = r ? L(r) : "";
  if (n)
    switch (n) {
      case Za:
        return Ze;
      case Ja:
        return ze;
      case Qa:
        return qe;
      case Va:
        return Xe;
      case ka:
        return Ye;
    }
  return t;
});
const K = I;
var ei = Object.prototype, ti = ei.hasOwnProperty;
function ri(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && ti.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var ni = m.Uint8Array;
const k = ni;
function Ie(e) {
  var t = new e.constructor(e.byteLength);
  return new k(t).set(new k(e)), t;
}
function ai(e, t) {
  var r = t ? Ie(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var ii = /\w*$/;
function oi(e) {
  var t = new e.constructor(e.source, ii.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Je = O ? O.prototype : void 0, Qe = Je ? Je.valueOf : void 0;
function si(e) {
  return Qe ? Object(Qe.call(e)) : {};
}
function mt(e, t) {
  var r = t ? Ie(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var fi = "[object Boolean]", ui = "[object Date]", ci = "[object Map]", li = "[object Number]", pi = "[object RegExp]", gi = "[object Set]", di = "[object String]", hi = "[object Symbol]", yi = "[object ArrayBuffer]", bi = "[object DataView]", _i = "[object Float32Array]", vi = "[object Float64Array]", Ti = "[object Int8Array]", $i = "[object Int16Array]", Ai = "[object Int32Array]", Oi = "[object Uint8Array]", wi = "[object Uint8ClampedArray]", mi = "[object Uint16Array]", Pi = "[object Uint32Array]";
function Si(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case yi:
      return Ie(e);
    case fi:
    case ui:
      return new n(+e);
    case bi:
      return ai(e, r);
    case _i:
    case vi:
    case Ti:
    case $i:
    case Ai:
    case Oi:
    case wi:
    case mi:
    case Pi:
      return mt(e, r);
    case ci:
      return new n();
    case li:
    case di:
      return new n(e);
    case pi:
      return oi(e);
    case gi:
      return new n();
    case hi:
      return si(e);
  }
}
function Pt(e) {
  return typeof e.constructor == "function" && !Ae(e) ? _r(Se(e)) : {};
}
var Ei = "[object Map]";
function Ii(e) {
  return w(e) && K(e) == Ei;
}
var Ve = R && R.isMap, Ci = Ve ? Oe(Ve) : Ii;
const ji = Ci;
var Li = "[object Set]";
function xi(e) {
  return w(e) && K(e) == Li;
}
var ke = R && R.isSet, Mi = ke ? Oe(ke) : xi;
const Ri = Mi;
var Fi = 1, Di = 2, Ni = 4, St = "[object Arguments]", Ui = "[object Array]", Gi = "[object Boolean]", Bi = "[object Date]", Hi = "[object Error]", Et = "[object Function]", Wi = "[object GeneratorFunction]", Ki = "[object Map]", zi = "[object Number]", It = "[object Object]", qi = "[object RegExp]", Xi = "[object Set]", Yi = "[object String]", Zi = "[object Symbol]", Ji = "[object WeakMap]", Qi = "[object ArrayBuffer]", Vi = "[object DataView]", ki = "[object Float32Array]", eo = "[object Float64Array]", to = "[object Int8Array]", ro = "[object Int16Array]", no = "[object Int32Array]", ao = "[object Uint8Array]", io = "[object Uint8ClampedArray]", oo = "[object Uint16Array]", so = "[object Uint32Array]", d = {};
d[St] = d[Ui] = d[Qi] = d[Vi] = d[Gi] = d[Bi] = d[ki] = d[eo] = d[to] = d[ro] = d[no] = d[Ki] = d[zi] = d[It] = d[qi] = d[Xi] = d[Yi] = d[Zi] = d[ao] = d[io] = d[oo] = d[so] = !0;
d[Hi] = d[Et] = d[Ji] = !1;
function J(e, t, r, n, a, i) {
  var o, s = t & Fi, f = t & Di, c = t & Ni;
  if (r && (o = a ? r(e, n, a, i) : r(e)), o !== void 0)
    return o;
  if (!P(e))
    return e;
  var l = $(e);
  if (l) {
    if (o = ri(e), !s)
      return st(e, o);
  } else {
    var p = K(e), u = p == Et || p == Wi;
    if (B(e))
      return $t(e, s);
    if (p == It || p == St || u && !a) {
      if (o = f || u ? {} : Pt(e), !s)
        return f ? Wa(e, Ma(o, e)) : Ga(e, xa(o, e));
    } else {
      if (!d[p])
        return a ? e : {};
      o = Si(e, p, s);
    }
  }
  i || (i = new A());
  var y = i.get(e);
  if (y)
    return y;
  i.set(e, o), Ri(e) ? e.forEach(function(_) {
    o.add(J(_, t, r, _, e, i));
  }) : ji(e) && e.forEach(function(_, g) {
    o.set(g, J(_, t, r, g, e, i));
  });
  var b = c ? f ? Ka : le : f ? D : q, v = l ? void 0 : b(e);
  return Cr(v || e, function(_, g) {
    v && (g = _, _ = e[g]), ft(o, g, J(_, t, r, g, e, i));
  }), o;
}
var fo = 1, uo = 4;
function co(e) {
  return J(e, fo | uo);
}
var lo = "__lodash_hash_undefined__";
function po(e) {
  return this.__data__.set(e, lo), this;
}
function go(e) {
  return this.__data__.has(e);
}
function ee(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new E(); ++t < r; )
    this.add(e[t]);
}
ee.prototype.add = ee.prototype.push = po;
ee.prototype.has = go;
function ho(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
function yo(e, t) {
  return e.has(t);
}
var bo = 1, _o = 2;
function Ct(e, t, r, n, a, i) {
  var o = r & bo, s = e.length, f = t.length;
  if (s != f && !(o && f > s))
    return !1;
  var c = i.get(e), l = i.get(t);
  if (c && l)
    return c == t && l == e;
  var p = -1, u = !0, y = r & _o ? new ee() : void 0;
  for (i.set(e, t), i.set(t, e); ++p < s; ) {
    var b = e[p], v = t[p];
    if (n)
      var _ = o ? n(v, b, p, t, e, i) : n(b, v, p, e, t, i);
    if (_ !== void 0) {
      if (_)
        continue;
      u = !1;
      break;
    }
    if (y) {
      if (!ho(t, function(g, T) {
        if (!yo(y, T) && (b === g || a(b, g, r, n, i)))
          return y.push(T);
      })) {
        u = !1;
        break;
      }
    } else if (!(b === v || a(b, v, r, n, i))) {
      u = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), u;
}
function vo(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
function To(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var $o = 1, Ao = 2, Oo = "[object Boolean]", wo = "[object Date]", mo = "[object Error]", Po = "[object Map]", So = "[object Number]", Eo = "[object RegExp]", Io = "[object Set]", Co = "[object String]", jo = "[object Symbol]", Lo = "[object ArrayBuffer]", xo = "[object DataView]", et = O ? O.prototype : void 0, fe = et ? et.valueOf : void 0;
function Mo(e, t, r, n, a, i, o) {
  switch (r) {
    case xo:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Lo:
      return !(e.byteLength != t.byteLength || !i(new k(e), new k(t)));
    case Oo:
    case wo:
    case So:
      return z(+e, +t);
    case mo:
      return e.name == t.name && e.message == t.message;
    case Eo:
    case Co:
      return e == t + "";
    case Po:
      var s = vo;
    case Io:
      var f = n & $o;
      if (s || (s = To), e.size != t.size && !f)
        return !1;
      var c = o.get(e);
      if (c)
        return c == t;
      n |= Ao, o.set(e, t);
      var l = Ct(s(e), s(t), n, a, i, o);
      return o.delete(e), l;
    case jo:
      if (fe)
        return fe.call(e) == fe.call(t);
  }
  return !1;
}
var Ro = 1, Fo = Object.prototype, Do = Fo.hasOwnProperty;
function No(e, t, r, n, a, i) {
  var o = r & Ro, s = le(e), f = s.length, c = le(t), l = c.length;
  if (f != l && !o)
    return !1;
  for (var p = f; p--; ) {
    var u = s[p];
    if (!(o ? u in t : Do.call(t, u)))
      return !1;
  }
  var y = i.get(e), b = i.get(t);
  if (y && b)
    return y == t && b == e;
  var v = !0;
  i.set(e, t), i.set(t, e);
  for (var _ = o; ++p < f; ) {
    u = s[p];
    var g = e[u], T = t[u];
    if (n)
      var X = o ? n(T, g, u, t, e, i) : n(g, T, u, e, t, i);
    if (!(X === void 0 ? g === T || a(g, T, r, n, i) : X)) {
      v = !1;
      break;
    }
    _ || (_ = u == "constructor");
  }
  if (v && !_) {
    var N = e.constructor, M = t.constructor;
    N != M && "constructor" in e && "constructor" in t && !(typeof N == "function" && N instanceof N && typeof M == "function" && M instanceof M) && (v = !1);
  }
  return i.delete(e), i.delete(t), v;
}
var Uo = 1, tt = "[object Arguments]", rt = "[object Array]", Y = "[object Object]", Go = Object.prototype, nt = Go.hasOwnProperty;
function Bo(e, t, r, n, a, i) {
  var o = $(e), s = $(t), f = o ? rt : K(e), c = s ? rt : K(t);
  f = f == tt ? Y : f, c = c == tt ? Y : c;
  var l = f == Y, p = c == Y, u = f == c;
  if (u && B(e)) {
    if (!B(t))
      return !1;
    o = !0, l = !1;
  }
  if (u && !l)
    return i || (i = new A()), o || we(e) ? Ct(e, t, r, n, a, i) : Mo(e, t, f, r, n, a, i);
  if (!(r & Uo)) {
    var y = l && nt.call(e, "__wrapped__"), b = p && nt.call(t, "__wrapped__");
    if (y || b) {
      var v = y ? e.value() : e, _ = b ? t.value() : t;
      return i || (i = new A()), a(v, _, r, n, i);
    }
  }
  return u ? (i || (i = new A()), No(e, t, r, n, a, i)) : !1;
}
function Ce(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !w(e) && !w(t) ? e !== e && t !== t : Bo(e, t, r, n, Ce, a);
}
var Ho = 1, Wo = 2;
function Ko(e, t, r, n) {
  var a = r.length, i = a, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); a--; ) {
    var s = r[a];
    if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++a < i; ) {
    s = r[a];
    var f = s[0], c = e[f], l = s[1];
    if (o && s[2]) {
      if (c === void 0 && !(f in e))
        return !1;
    } else {
      var p = new A();
      if (n)
        var u = n(c, l, f, e, t, p);
      if (!(u === void 0 ? Ce(l, c, Ho | Wo, n, p) : u))
        return !1;
    }
  }
  return !0;
}
function jt(e) {
  return e === e && !P(e);
}
function zo(e) {
  for (var t = q(e), r = t.length; r--; ) {
    var n = t[r], a = e[n];
    t[r] = [n, a, jt(a)];
  }
  return t;
}
function Lt(e, t) {
  return function(r) {
    return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
  };
}
function qo(e) {
  var t = zo(e);
  return t.length == 1 && t[0][2] ? Lt(t[0][0], t[0][1]) : function(r) {
    return r === e || Ko(r, e, t);
  };
}
function Xo(e, t) {
  return e != null && t in Object(e);
}
function Yo(e, t, r) {
  t = ht(t, e);
  for (var n = -1, a = t.length, i = !1; ++n < a; ) {
    var o = ie(t[n]);
    if (!(i = e != null && r(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != a ? i : (a = e == null ? 0 : e.length, !!a && $e(a) && Te(o, a) && ($(e) || V(e)));
}
function Zo(e, t) {
  return e != null && Yo(e, t, Xo);
}
var Jo = 1, Qo = 2;
function Vo(e, t) {
  return me(e) && jt(t) ? Lt(ie(e), t) : function(r) {
    var n = Ta(r, e);
    return n === void 0 && n === t ? Zo(r, e) : Ce(t, n, Jo | Qo);
  };
}
function ko(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function es(e) {
  return function(t) {
    return yt(t, e);
  };
}
function ts(e) {
  return me(e) ? ko(ie(e)) : es(e);
}
function rs(e) {
  return typeof e == "function" ? e : e == null ? _e : typeof e == "object" ? $(e) ? Vo(e[0], e[1]) : qo(e) : ts(e);
}
function ns(e) {
  return function(t, r, n) {
    for (var a = -1, i = Object(t), o = n(t), s = o.length; s--; ) {
      var f = o[e ? s : ++a];
      if (r(i[f], f, i) === !1)
        break;
    }
    return t;
  };
}
var as = ns();
const xt = as;
function is(e, t) {
  return e && xt(e, t, q);
}
function he(e, t, r) {
  (r !== void 0 && !z(e[t], r) || r === void 0 && !(t in e)) && te(e, t, r);
}
function os(e) {
  return w(e) && re(e);
}
function ye(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
function ss(e) {
  return F(e, D(e));
}
function fs(e, t, r, n, a, i, o) {
  var s = ye(e, r), f = ye(t, r), c = o.get(f);
  if (c) {
    he(e, r, c);
    return;
  }
  var l = i ? i(s, f, r + "", e, t, o) : void 0, p = l === void 0;
  if (p) {
    var u = $(f), y = !u && B(f), b = !u && !y && we(f);
    l = f, u || y || b ? $(s) ? l = s : os(s) ? l = st(s) : y ? (p = !1, l = $t(f, !0)) : b ? (p = !1, l = mt(f, !0)) : l = [] : vt(f) || V(f) ? (l = s, V(s) ? l = ss(s) : (!P(s) || ve(s)) && (l = Pt(f))) : p = !1;
  }
  p && (o.set(f, l), a(l, f, n, i, o), o.delete(f)), he(e, r, l);
}
function Mt(e, t, r, n, a) {
  e !== t && xt(t, function(i, o) {
    if (a || (a = new A()), P(i))
      fs(e, t, o, r, Mt, n, a);
    else {
      var s = n ? n(ye(e, o), i, o + "", e, t, a) : void 0;
      s === void 0 && (s = i), he(e, o, s);
    }
  }, D);
}
var us = ut(function(e, t, r, n) {
  Mt(e, t, r, n);
});
const cs = us;
function ls(e, t) {
  var r = {};
  return t = rs(t), is(e, function(n, a, i) {
    te(r, t(n, a, i), n);
  }), r;
}
const ps = /([\p{Ll}\d])(\p{Lu})/gu, gs = /(\p{Lu})([\p{Lu}][\p{Ll}])/gu, ds = /(\d)(\p{Ll})/gu, hs = /(\p{L})(\d)/gu, ys = /[^\p{L}\d]+/giu, Z = "$1\0$2";
function bs(e, t = {}) {
  let r = e.replace(ps, Z).replace(gs, Z);
  t.separateNumbers && (r = r.replace(ds, Z).replace(hs, Z)), r = r.replace(ys, "\0");
  let n = 0, a = r.length;
  for (; r.charAt(n) === "\0"; )
    n++;
  if (n === a)
    return [];
  for (; r.charAt(a - 1) === "\0"; )
    a--;
  return r.slice(n, a).split(/\0/g);
}
function Rt(e, t) {
  const r = _s(t == null ? void 0 : t.locale), n = vs(t == null ? void 0 : t.locale), a = Ts(r, n);
  return bs(e, t).map((i, o) => o === 0 ? r(i) : a(i, o)).join("");
}
function _s(e) {
  return e === !1 ? (t) => t.toLowerCase() : (t) => t.toLocaleLowerCase(e);
}
function vs(e) {
  return e === !1 ? (t) => t.toUpperCase() : (t) => t.toLocaleUpperCase(e);
}
function Ts(e, t) {
  return (r, n) => {
    const a = r[0];
    return (n > 0 && a >= "0" && a <= "9" ? "_" + a : t(a)) + e(r.slice(1));
  };
}
function $s(e, t) {
  const r = /* @__PURE__ */ Object.create(null), n = e.split(",");
  for (let a = 0; a < n.length; a++)
    r[n[a]] = !0;
  return t ? (a) => !!r[a.toLowerCase()] : (a) => !!r[a];
}
const As = /* @__PURE__ */ $s("String,Number,Boolean,Function,Symbol,BigInt");
function Os(e) {
  const t = e == null ? void 0 : e.toString().match(/^\s*function (\w+)/);
  return t ? t[1] : e === null ? "null" : "";
}
function ws(e, t) {
  let r;
  const n = Os(t);
  if (As(n)) {
    const a = typeof e;
    r = a === n.toLowerCase(), !r && a === "object" && (r = e instanceof t);
  } else
    n === "Object" ? r = P(e) : n === "Array" ? r = Array.isArray(e) : n === "null" ? r = e === null : r = e instanceof t;
  return {
    valid: r,
    expectedType: n
  };
}
function ms({
  prop: e,
  type: t,
  validator: r
}) {
  if (![void 0, null].includes(e) && t) {
    let n = !1;
    const a = Array.isArray(t) ? t : [t], i = [];
    for (let o = 0; o < a.length && !n; o++) {
      const { valid: s, expectedType: f } = ws(e, a[o]);
      i.push(f || ""), n = s;
    }
    if (!n)
      throw new Error(
        `Invalid prop: type check failed, expecting [${i.join(
          ", "
        )}], receiving: ${e}`
      );
  }
  if (r && !r(e))
    throw new Error(`Invalid prop: validator check failed, receiving: ${e}`);
}
function Ps(e, {
  mergeObject: t,
  mergeFunction: r
}) {
  const n = [];
  for (let i = e.length - 1; i >= 0; i--)
    n.push(e[i]);
  const a = r ? (i, o) => typeof i == "function" && typeof o == "function" ? r(o, i) : void 0 : void 0;
  return t === "deep" ? cs(...n, a) : Fn(...n, a);
}
function Ss(e, {
  mergeFunction: t
}) {
  return e.reduce(t, () => {
  });
}
function Es(e, t = {}) {
  const {
    type: r,
    default: n,
    defaultIsDynamic: a = !1,
    required: i = !1,
    validator: o,
    camelizeObjectKeys: s = !1,
    mergeObjectApplyOnlyToDefault: f = !1,
    mergeFunctionApplyOnlyToDefault: c = !0
  } = t;
  let { mergeObject: l = "deep", mergeFunction: p = !1 } = t;
  const u = [];
  let y, b = !1, v = !1;
  const _ = (g) => {
    if (g !== void 0) {
      ms({ type: r, prop: g, validator: o });
      const T = vt(g), X = typeof g == "function";
      return b = T, v = X, T ? (g = co(g), s ? ls(
        g,
        (N, M) => Rt(M, {
          stripRegexp: /-/g
          // Filter only short horizontal lines for kebab-case conversion to camelCase
        })
      ) : g) : g;
    }
  };
  for (const g of e)
    u.push(_(g));
  if (!a)
    u.push(_(n));
  else if (typeof n != "function")
    throw new TypeError(
      `Invalid option: config.default should be Function when config.defaultIsDynamic enabled, receiving: ${n}`
    );
  b || (l = !1, v || (p = !1));
  for (let g = 0; g < u.length; g++) {
    const T = u[g];
    if (T !== void 0) {
      g === u.length - 1 ? y = T : l ? y = Ps(
        f ? [T, n] : u,
        {
          mergeObject: l,
          mergeFunction: p
        }
      ) : p ? y = Ss(
        c ? [T, n] : u,
        {
          mergeFunction: p
        }
      ) : y = T;
      break;
    }
  }
  if (i && [void 0, null].includes(y))
    throw new Error("Missing required prop");
  return a ? Es(e, {
    ...t,
    default: n(y),
    defaultIsDynamic: !1
  }) : y;
}
function Is(e, t) {
  return Object.keys(e).filter((r) => t(r)).reduce((r, n) => (r[n] = e[n], r), {});
}
function js(e) {
  return Is(e, (t) => !t.startsWith("hook:"));
}
function Ls(e) {
  if (Object.getOwnPropertyNames(e || {}).length) {
    const t = this.$emit;
    this.$emit = function(...r) {
      var i;
      t.apply(this, r);
      const [n, ...a] = r;
      (i = e[n]) == null || i.apply(this, a);
    };
  }
}
function ue(e) {
  const t = Array.from(Rt(e, {
    stripRegexp: /-/g
    // Filter only short horizontal lines for kebab-case conversion to camelCase
  }));
  return t[0] = t[0].toUpperCase(), t.unshift("o", "n"), t.join("");
}
function xs(e, t = []) {
  const r = {
    props: {},
    attrs: {},
    listeners: {},
    hooks: {},
    slots: {}
  }, n = Array.isArray(t) ? t : Object.keys(t);
  for (const a in e)
    if (a.startsWith("@")) {
      const i = a.substring(1);
      Ft ? i.startsWith("vue:") ? r.hooks[ue(i.replace("vue:", "vnode-"))] = e[a] : i.startsWith("vnode") ? r.hooks[ue(i)] = e[a] : r.listeners[ue(i)] = e[a] : i.startsWith("hook:") ? r.hooks[i] = e[a] : r.listeners[i] = e[a];
    } else if (a.startsWith("#")) {
      const i = a.substring(1);
      i && (r.slots[i] = e[a]);
    } else
      n.includes(a) ? r.props[a] = e[a] : r.attrs[a] = e[a];
  return r;
}
export {
  Es as conclude,
  js as getLocalListeners,
  Ls as listenGlobalHooks,
  xs as resolveConfig
};
//# sourceMappingURL=vue-global-config.mjs.map
